import k from '../k'
import { stats } from '../state/globals'
import gameOver from './gameOver'

k.loadSprite('emotes', 'sprites/emotes.png', {
  sliceX: 4,
  anims: {
    happy: 0,
    sleep: 1,
    distress: 2,
    finish: 3
  }
})

export default (level: number) => {
  const ui = k.add([k.sprite('ui'), k.fixed(), k.z(20)])
  const energy = ui.add([
    k.rect(60, 5, { radius: 1 }),
    k.pos(112, 204),
    k.color(115, 129, 123)
  ])
  const durability = ui.add([
    k.rect(60, 5, { radius: 1 }),
    k.pos(112, 217),
    k.color(57, 44, 49)
  ])
  ui.add([
    k.text(level.toString(), {
      font: 'pixel',
      size: 12
    }),
    k.color(57, 44, 49),
    k.pos(100, 183)
  ])
  const partDisplay = ui.add([
    k.text(stats.parts.toString(), {
      font: 'pixel',
      size: 12
    }),
    k.color(57, 44, 49),
    k.pos(145, 183)
  ])
  const emote = ui.add([k.sprite('emotes'), k.pos(25, 189)])

  energy.onUpdate(() => (energy.width = Math.round(stats.energy)))
  durability.onUpdate(() => (durability.width = Math.round(stats.durability)))
  emote.onUpdate(() => {
    if (stats.finish) emote.play('finish')
    else if (stats.isCharging) emote.play('sleep')
    else if (stats.sleepy || stats.broken) emote.play('distress')
    else emote.play('happy')
  })

  k.onKeyPress('r', () => {
    if (!stats.finish) gameOver('self destruct')
  })

  return { ui, partDisplay }
}
